const pageUrlCleaner = ({path = '/'}) =>  path.split('/').pop();

export default pageUrlCleaner;
